import * as React from "react";
const SvgBars = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: 10.9999,
	y: 8.00024,
	width: 3,
	height: 30,
	rx: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 26.0001,
	y: 2,
	width: 3,
	height: 30,
	rx: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 19.9999,
	y: 13.9998,
	width: 3,
	height: 9,
	rx: 1.5,
	transform: "rotate(90 19.9999 13.9998)"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 28.9999,
	y: 4.99976,
	width: 3,
	height: 9,
	rx: 1.5,
	transform: "rotate(90 28.9999 4.99976)"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 14,
	y: 29,
	width: 3,
	height: 9,
	rx: 1.5,
	transform: "rotate(90 14 29)"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 35.0001,
	y: 20,
	width: 3,
	height: 9,
	rx: 1.5,
	transform: "rotate(90 35.0001 20)"
}));
export default SvgBars;
